import "core-js/stable";
import "regenerator-runtime/runtime";
import * as $ from 'jquery';
import * as bootstrap from 'bootstrap';
import './../../../../jb-nexus-child/assets/src/js/index';
import 'lit';
import { ShowCaseComponent } from './showcase.component.js';
import { BootstrapCarouselModule } from './modules/bootstrap-carousel.module';
import { LazyLoadModule } from './modules/lazy-load.module';
import { HyphenationModule } from './modules/hyphenation.module';
import { CookieModule } from './modules/cookie.module';
import { HorizontalScrollContainerComponent } from './modules/horizontal-scroll-container.component.js';
import { BootstrapNavigationBarModule } from './modules/bootstrap-navigation-bar.module';
import { BootstrapFormValidationModule } from './modules/bootstrap-form-validation.module';
import { MediumZoomModule } from './modules/medium-zoom.module';
import { VideoPlayerModule } from './modules/video-player.module';
import { IframeResizeModule } from './modules/iframe.resize.module';
import { GridItemComponent } from './grid-item.component';
import { ClipboardModule } from "./modules/clipboard.module.js"
import { GooglePublisherTagModule } from './modules/google-publisher-tag.module.js';
// import { FloatingButtonComponent } from './modules/floating-button.component.js';
import { ColorModule } from './modules/color.module.js';
import { ProgramModule } from './modules/program/program.module.js';
import { ThemePickerComponent } from './modules/theme-picker.component.js';
import { PostFiltersModule } from './modules/post-filters.module.js';
import { PhotoSliderModule } from './modules/photo-slider.module.js';
import { ExhibitorOverviewModule } from './modules/exhibitor-overview.module.js';
import { SessionsModule } from './modules/session/sessions.module.js';
import './tickets-components.js';
import { CustomDropdowns } from "./modules/custom-dropdown.js";
import { TextResizerModule } from "./modules/text-resizer.module.js";
import { AgendaModule } from "./modules/agenda/agenda.module.js";
import { AnalyticsModule } from "./modules/analytics.module.js";
import { AutoCompleteModule } from "./modules/autocomplete.module.js";
import './modules/nexus-search.component.js';
import { GenericStateMachineEventsModule } from "./modules/generic-state-machine-events.module.js";
import { StateMachineBasedBootstrapNavigationBarModule } from "./modules/state-machine-based-bootstrap-navigation-bar.module.js";
import { PledgeModule } from "./modules/pledge/pledge.module.js";
import { FileUploaderModule } from "./modules/file-uploader.js";
import { CounterModule } from "./modules/counter.module.js";
import { NotificationModule } from "./modules/notification.module.js";
import { PledgeCanvasModule } from "./modules/pledge/pledge-canvas.module.js";
import './modules/language-switcher.component.js';
import LocationSearchModule from "./modules/location-search/index.js";
import './components/svg-animation.component.js';
import './components/uutje-404-svg-animation.component.js';
import { JumbotronColorModule } from "./modules/jumbotron-color.module.js";
import { TextToSpeechModule } from "./modules/text-to-speech.module.js";

(function () {
	'use strict';

	var modules = [
		// make a class with an initialize function and add it here
		new GenericStateMachineEventsModule(),
		new TextToSpeechModule(),
		new BootstrapCarouselModule(),
		new LazyLoadModule(),
		new VideoPlayerModule(),
		new AnalyticsModule(),
		new CookieModule(),
		new HorizontalScrollContainerComponent(),
		new GridItemComponent(),
		new StateMachineBasedBootstrapNavigationBarModule(),
		new BootstrapFormValidationModule(),
		new MediumZoomModule(),
		new ColorModule(),
		new JumbotronColorModule(),
		new IframeResizeModule(),
		new ClipboardModule(),
		new GooglePublisherTagModule(),
		// new FloatingButtonComponent(),
		new ProgramModule(),
		new PostFiltersModule(),
		new PhotoSliderModule(),
		new ThemePickerComponent(),
		new ExhibitorOverviewModule(),
		new SessionsModule(),
		new CustomDropdowns(),
		new TextResizerModule(),
		new AgendaModule(),
		new PledgeModule(),
		new PledgeCanvasModule(),
		new FileUploaderModule(),
		new CounterModule(),
		new NotificationModule(),
		new LocationSearchModule(),
	];
	modules.forEach((module) => {
		module.initialize();
	})

	window.addEventListener('load', () => {
		import('./modules/hyphenation.module').then((module) => {
			if (module.HyphenationModule) {
				let m = new module.HyphenationModule();
				m.initialize();
			}
		});
	});

})();